"use strict";

/**
 * Oude legacy code, gekopieerd uit dtps/htdocs/js/tabs.js.
 *
 * options.activeTab = 'activeTabLabel'
 * options: {tabsId, contentId, classNameContentLinks, options, tabList}
 * options.tabsID : the id of the element that will have (or already has) the tabs
 * options.contentID: the id of the element
 * that will hold the content that loads after clicking a tab.
 * options.classNameContentLinks : the classname of elements that contain the content link
 * :click-eventlistener will be added that will create tab & open content
 * options.options = { *** niet verplicht ***
 * closeButtonNewTabs: true,
 * refreshButtonNewTabs: true,
 * }
 * options.tabList = [ *** niet verplicht ***
 * {
 * caption: 'caption',
 * url: 'url',
 * content: 'content'
 * { ... }
 * ]
 * @param options
 * @constructor
 */
window.Tabs = function Tabs(options) {
	let _this = this;

	this.tabsId = options.tabsId;
	this.contentId = options.contentId;
	this.classNameContentLinks = options.classNameContentLinks;
	this.options = { // defaults
		closeButtonNewTabs: true,
		refreshButtonNewTabs: true
	};
	this.tabsLoadingContent = [];

	if (options.options && typeof options.options === "object") {
		this.options = extendDefaults(options.options, _this.options);
	}
	if (options.tabsId) {
		this.tabList = document.getElementById(options.tabsId).children;
	}
	if (options.tabList) {
		this.tabListOptions = options.tabList;

		if (options.activeTab) {
			// yes, it's weird (but correct) that it uses makeSafeForCSS twice. 
			const activeTab = makeSafeForCSS(makeSafeForCSS(options.activeTab));
			sessionStorage.setItem('sessionsActiveTab-' + options.tabsId, activeTab);
		}
		this.createTabs();
	}
};

Tabs.prototype.addEventListenerToExistingTabs = function () {
	// *** mogelijk extern aangeroepen ***
	let _this = this;
	for (let i = 0; i < this.tabList.length; i++) {
		let tablink = this.tabList[i];
		tablink.onclick = function (e) {
			_this.openTab(e.target.id);
		};
	}
	return this;
};

Tabs.prototype.showOnlyActiveTab = function () {
	// *** mogelijk extern aangeroepen ***
	let activeTab = sessionStorage.getItem('sessionsActiveTab-' + this.tabsId);

	if (activeTab == undefined || activeTab == null || activeTab == 'null') {
		this.openFirstTab();
	} else {
		this.openTab(activeTab);
	}

	return this;
};

Tabs.prototype.createTabs = function () {
	if (this.tabListOptions[0].hasOwnProperty("url") && this.tabListOptions[0].url) {
		for (let i = 0; i < this.tabListOptions.length; i++) {
			let url = this.tabListOptions[i].url;
			let label = this.tabListOptions[i].caption;
			this.addTab(label, url, 'noClose');
		}

		let activeTab = sessionStorage.getItem('sessionsActiveTab-' + this.tabsId);

		if (!activeTab && this.tabList[0].innerText == this.tabListOptions[0].caption) {
			let url = this.tabListOptions[0].url;
			this.addTabContentFromURL(url);
		}
	} else if (this.tabListOptions[0].hasOwnProperty("caption") && this.tabListOptions[0].caption) {
		for (let i = 0; i < this.tabListOptions.length; i++) {
			let label = this.tabListOptions[i].caption;
			const id = makeSafeForCSS(label);
			let content = this.tabListOptions[i].content;
			this.addTab(label, id, 'noClose', 'noRefresh');
			this.addTabContentFromContent(content, id);
		}
	} else {
		for (let i = 0; i < this.tabListOptions.length; i++) {
			const id = makeRandomID();
			let label = this.tabListOptions[i].caption;
			let content = this.tabListOptions[i].content;
			this.addTab(label, id, 'noClose', 'noRefresh');
			this.addTabContentFromContent(content, id);
		}
	}

	this.showOnlyActiveTab();

	return this;
};
Tabs.prototype.addSelect = function (url, label, index, findByLabel) {
	// adds tabs
	let idx = this._getIndex(index);
	const newURL = makeSafeForCSS(url);

	if (idx == -1) {
		this.addTab(label, url);
	}
	this.openTab(newURL);
	return this;
};

Tabs.prototype.addTab = function (label, url, closeButton, refreshButton) {
	// load defaults
	if (typeof closeButton == 'undefined') { closeButton = 'close'; }
	if (typeof refreshButton == 'undefined') { refreshButton = 'refresh'; }

	// add tabs
	for (let i = 0; i < this.tabList.length; i++) {
		this.tabList[i].className = this.tabList[i].className.replace(" active", "");
	}

	let tabs = document.getElementById(this.tabsId);
	let li = this.createNewListNode(label, url, closeButton, refreshButton);
	tabs.appendChild(li);

	return this;
};

Tabs.prototype.addTabContentFromURL = function (url, identifier = null) {
	let _this = this;
	let newURL = makeSafeForCSS(url);
	if (identifier !== null) {
		newURL = identifier;
	}

	if (this.tabsLoadingContent.indexOf(newURL) == -1) {
		this.tabsLoadingContent.push(newURL);
		// Show tab loader mask
		let content = document.getElementById(this.contentId);
		let loader = document.createElement('div');
		loader.setAttribute('class', 'dtps_loader spinner middle');
		content.insertBefore(loader, content.childNodes[0]);

		this.getXhr(url, function (data) {
			if (data.status === 200) {
				_this.addElement("section", newURL, data.response);
			} else {
				_this.addElement("section", newURL, '<p class="dtps_missing_data_error "><i class="fa fa-warning"/> Er is een fout opgetreden</p>');
			}
			_this.tabsLoadingContent = _this.tabsLoadingContent.filter(item => item !== newURL);
		});
	}

	return this;
};

Tabs.prototype.addTabContentFromContent = function (content, id) {
	const newID = makeSafeForCSS(id);
	this.addElement("section", newID, content);

	return this;
};

Tabs.prototype.openTab = function (identifier) {
	let tab = document.getElementById(identifier);
	if (tab !== null) {
		sessionStorage.setItem('sessionsActiveTab-' + this.tabsId, identifier); // gebruik browserstorage om actieve tab te bewaren.
		this.hideAllContent().showContent(identifier); // shows content of tab we want to see and hides the rest
		// show tab as selected (add class)
		let tabList = document.getElementById(this.tabsId);
		// console.log('tabList', tabList)
		for (let i = 0; i < tabList.children.length; i++) {
			tabList.children[i].className = tabList.children[i].className.replace("active", "");
		}
		tabList.getElementsByClassName(identifier)[0].classList.add("active");
		window.scrollTo(window.scrollX, window.scrollY - 1);
		window.scrollTo(window.scrollX, window.scrollY + 1);
		return this;
	} else {
		this.openFirstTab();
	}

};

Tabs.prototype.closeTab = function (identifier) {

	let tabList = document.getElementById(this.tabsId);
	let tab = tabList.getElementsByClassName(identifier)[0];

	if (tab.classList.contains('active')) {
		// if currenttab != closed tab: stay there

		// if close current tab:
		if (tab.nextSibling) {
			// if current tab != last tab: open next tab.
			this.openTab(tab.nextSibling.id);
		} else {
			// if current tab == last tab: open last tab left.
			this.openTab(tabList.lastChild.previousElementSibling.id);
		}
	}
	tabList.removeChild(tab);

	this.removeContent(identifier);
};

Tabs.prototype.refreshTab = function (identifier) {
	let tab = document.getElementById(identifier);
	if (tab === null) {
		console.log('tab === null > now what?');
	} else {
		const url = tab.dataset.url;
		this.removeContent(identifier);
		this.addTabContentFromURL(url);
	}
	return this;
};

Tabs.prototype.createNewListNode = function (label, url, closeButton, refreshButton) {
	let _this = this;
	const newURL = makeSafeForCSS(url);
	let close = true;
	let refresh = true;
	if (closeButton === 'noClose') {
		close = false;
	}
	if (refreshButton === 'noRefresh') {
		refresh = false;
	}
	let li = document.createElement("li");
	li.classList.add("tablinks");
	li.classList.add(newURL);
	li.setAttribute("data-url", url);
	li.id = newURL;

	if (this.options.refreshButtonNewTabs && refresh) {
		const refreshButton = newFAElement("fa fa-refresh", "refresh");
		refreshButton.addEventListener("click", function (event) {
			let active = event.target.closest('.active');
			// console.log('refreshbutton clicked')
			if (active) {
				// console.log('refresh button tries to refresh')
				_this.refreshTab(newURL);
				event.stopImmediatePropagation();
			}
		});
		li.appendChild(refreshButton);
	}
	let textnode = document.createTextNode(label);
	li.appendChild(textnode);
	if (this.options.closeButtonNewTabs && close) {
		const closeButton = newFAElement("fa fa-close", "close");
		closeButton.addEventListener("click", function (event) {
			_this.closeTab(newURL);
			event.stopImmediatePropagation();
		});
		li.appendChild(closeButton);
	}
	li.setAttribute("id", newURL);
	li.onclick = function () {
		_this.openTab(newURL);
	};
	return li;
};

Tabs.prototype.AddContentLinks = function () {
	// zie realisatie-formatie usecase.
	console.log('evt nog doen: algemene addcontentlinks methode');
	return this;
};

/* help methods */

Tabs.prototype._getIndex = function (index) {
	if (this.tabList.length > 0) {
		for (let i = 0; i < this.tabList.length; i++) {
			if (this.tabList[i].id === index) {
				return i;
			}
		}
		return -1;
	}
	return index;
};

Tabs.prototype.showContent = function (identifier) {

	let tabcontent = document.getElementById(this.contentId);

	let elems = tabcontent.getElementsByClassName(identifier);
	// check of tab hoort te bestaan... zo niet, laat eerste tab zien.
	// console.log('showcontent: elems', elems)
	if (elems.length > 0) {
		[].forEach.call(elems, function (el) {
			el.classList.remove("hide");
		});
	} else {
		this.refreshTab(identifier);
	}

	return this;
};

Tabs.prototype.hideAllContent = function (exceptIndex) {
	// exceptIndex: content that will be shown
	let children = document.getElementById(this.contentId).children;

	for (let i = 0; i < children.length; i++) {
		if (i === exceptIndex) {
			children[i].classList.remove("hide");
			continue;
		}
		children[i].classList.add("hide");
	}
	return this;
};

Tabs.prototype.removeContent = function (identifier) {
	let tabcontent = document.getElementById(this.contentId);
	const content = tabcontent.getElementsByClassName(identifier)[0];
	if (content) {
		tabcontent.removeChild(content);
	}
};

Tabs.prototype.addElement = function (elementTag, elementId, html) {
	// console.log('addElement', this.contentId)
	// Adds an element to the document
	const parentId = this.contentId;
	const id = makeRandomID();
	const p = document.getElementById(parentId);
	let newElement = document.createElement(elementTag);
	newElement.setAttribute("class", elementId);
	newElement.setAttribute("id", id);
	newElement.innerHTML = html;
	if (!document.getElementById(elementId).classList.contains('active')) {
		// Tab inhoud is geladen, maar tab is niet meer actief.
		newElement.classList.add('hide');
	}
	p.appendChild(newElement);

	// from https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
	let scripts = Array.prototype.slice.call(document.getElementById(id).getElementsByTagName("script"));
	// console.log('scripts', scripts)
	for (let i = 0; i < scripts.length; i++) {
		if (scripts[i].src != "") {
			let tag = document.createElement("script");
			tag.src = scripts[i].src;
			document.getElementsByTagName("head")[0].appendChild(tag);
		} else {
			// console.log('scripts[i].innerHTML', scripts[i].innerHTML)
			window.eval(scripts[i].innerHTML);
		}
	}

	return this;
};

// ipv $.get
Tabs.prototype.getXhr = function (url, onload) {

	// onload: function that is entered when getXhr is called
	let xhr = new XMLHttpRequest();
	let _this = this;
	xhr.open('GET', url, true);

	// The XMLHttpRequest method send() sends the request to the server.
	// If the request is asynchronous,
	// this method returns as soon as the request is sent and the result is delivered using events.
	xhr.send();
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4) {
			onload(xhr);
			// Remove loader
			let loader = document.getElementById(_this.contentId).getElementsByClassName('dtps_loader')[0];
			if (loader.parentNode) {
				loader.parentNode.removeChild(loader);
			} else {
				document.body.removeChild(loader);
			}
		}
	};
	return this;
};

Tabs.prototype.openFirstTab = function () {
	[].forEach.call(this.tabList, function (el) {
		el.classList.remove("active");
	});
	this.tabList[0].classList.add("active");
	this.hideAllContent(0);
};

/* helper functions */

window.windowOnLoad = function (f) {
	const oldOnLoad = window.onload;
	if (typeof window.onload != 'function') {
		window.onload = f();
	} else {
		window.onload = function () {
			oldOnLoad();
			f();
		};
	}
};

window.extendDefaults = function (properties, source) {
	for (let property in properties) {
		if (properties.hasOwnProperty(property)) {
			source[property] = properties[property];
		}
	}

	return source;
};

window.makeSafeForCSS = function (name, voorvoegsel) {
	if (voorvoegsel === undefined) {
		voorvoegsel = "";
	}
	return name.replace(/[^a-z0-9]/g, function (s) {
		const c = s.charCodeAt(0);
		if (c == 32) return '-';
		if (c >= 65 && c <= 90) return '_' + s.toLowerCase();
		return voorvoegsel + '_js_' + ('000' + c.toString(16)).slice(-4);
	});
};

window.newFAElement = function (faElement, title) {
	// font awesome element creator
	let FAIcon = document.createElement("span");
	let Icon = document.createElement("i");
	Icon.className = faElement;
	Icon.setAttribute("aria-label", title);
	Icon.setAttribute("title", title);
	FAIcon.appendChild(Icon);
	return Icon;
};

window.makeRandomID = function () {
	let text = "";
	const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

	for (let i = 0; i < 7; i++)
		text += possible.charAt(Math.floor(Math.random() * possible.length));

	return text;
};